<template>
  <div class="modatta-footer">
    <div class="modatta-container">
      <div class="footer-top">
        <router-link to="/" class="logo">
          <img src="/svg/modatta-logo.svg" alt="Modatta Logo" />
        </router-link>
        <div class="social-media-links">
          <modatta-language-dropdown></modatta-language-dropdown>
        </div>
      </div>
      <div class="sub-footer">
        <div class="start">© {{ new Date().getFullYear() }} Modatta Brasil, Ltda</div>
        <div class="center">
            <a href="mailto:meajuda@modatta.com.br" v-html="$t('footer.support_email')"></a>
        </div>
        <div class="end">
          <a
            href="http://www.modatta.com.br/privacy-policy.html"
            target="_blank"
            class="footer-link"
            v-html="$t('footer.privacy_policy')"
          ></a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
};
</script>